import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './core/_layoutComponents/footer/footer.component';
import { BreadcrumbComponent } from './core/_layoutComponents/breadcrumb/breadcrumb.component';
import { HeaderComponent } from './core/_layoutComponents/header/header.component';
import { HomeComponent } from './features/home/home.component';



import { LabelModule } from '@progress/kendo-angular-label';

import { FormFieldModule,  TextBoxModule } from '@progress/kendo-angular-inputs';
import { CurrencyPipe, LocationStrategy, PathLocationStrategy } from '@angular/common';

import { RouterModule } from '@angular/router';
import { HttpClientJsonpModule, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import 'hammerjs';

import { PrimeNgModule } from './core/library/prime-ng/prime-ng.module';
import { KendoModule } from './core/library/kendo/kendo.module';
import { SignInComponent } from './core/_layoutComponents/header/sign-in/sign-in.component';
import { SearchComponent } from './core/_layoutComponents/header/search/search.component';
import { MenuComponent } from './core/_layoutComponents/header/menu/menu.component';
import { AdvanceSearchComponent } from './features/advance-search/advance-search.component';
import { NotifyComponent } from './shared/components/notify/notify.component';
import { CookieService } from 'ngx-cookie-service';
import { CartComponent } from './features/cart/cart.component';
import { NgxPaginationModule } from 'ngx-pagination'; // <-- import the ngx pagination

import { ManageAttributeComponent } from "./features/buildPak/admin/manage-attribute/manage-attribute.component";
import { CheckoutComponent } from './features/checkout/checkout.component';
import { OrderdetailsComponent } from './features/checkout/order-details/order-details.component';
import { CustomerAddressComponent } from './features/checkout/customer-address/customer-address.component';
import { CartReviewComponent } from './features/checkout/cart-review/cart-review.component';
import { ManageAddressComponent } from './features/checkout/customer-address/manage-address/manage-address.component';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { BuildAndBuyComponent } from './features/build-and-buy/build-and-buy.component';
import { ProductCategoryComponent } from './features/build-and-buy/product-category/product-category.component';
import { ProductComponent } from './features/build-and-buy/product/product.component';
import { ProductConfigurationComponent } from './features/build-and-buy/product-configuration/product-configuration.component';
import { InfoComponent } from './shared/components/info/info.component';
import { OrderManagementComponent } from './features/order-management/order-management.component';
import { ManageQuoteComponent } from './features/order-management/manage-quote/manage-quote.component';
import { RequestQuoteComponent } from './features/order-management/manage-quote/request-quote/request-quote.component';
import { FactoryQuoteRequestComponent } from './features/order-management/manage-quote/factory-quote-request/factory-quote-request.component';
import { InvoiceInquiryComponent } from './features/order-management/invoice-inquiry/invoice-inquiry.component';
import { KawneerdirectQuotesComponent } from './features/order-management/manage-quote/kawneerdirect-quotes/kawneerdirect-quotes.component';
import { InHouseQuotesComponent } from './features/order-management/manage-quote/in-house-quotes/in-house-quotes.component';
import { CaPropComponent } from './shared/components/ca-prop/ca-prop.component';
import { InvoiceDetailComponent } from './features/order-management/invoice-inquiry/invoice-detail/invoice-detail.component';
import { OrderInquiryComponent } from './features/order-management/order-inquiry/order-inquiry.component';
import { OrderDetailComponent } from './features/order-management/order-inquiry/order-detail/order-detail.component';
import { QuoteDetailComponent } from './features/order-management/manage-quote/kawneerdirect-quotes/quote-detail/quote-detail.component';
import { QuickAddQuoteComponent } from './features/order-management/manage-quote/kawneerdirect-quotes/quote-detail/quick-add-quote/quick-add-quote.component';
import { ManageCompanyComponent } from './features/manage-company/manage-company.component';
import { ManageAccountComponent } from './features/manage-company/manage-account/manage-account.component';
import { ManageProductComponent } from './features/buildPak/admin/manage-product/manage-product.component';
import { AddNewProductComponent } from './features/buildPak/admin/manage-product/add-new-product/add-new-product.component';
import { CreditReferenceComponent } from './features/self-service-utilities/credit-reference/credit-reference.component';
import { SubmittalPackageComponent } from './features/self-service-utilities/submittal-package/submittal-package.component';
import { CustomerMultiplierPlanComponent } from './features/customer-multiplier/customer-multiplier-plan/customer-multiplier-plan.component';
import { CustomTermsConditionsNotesComponent } from './features/custom-terms-conditions-notes/custom-terms-conditions-notes.component';
import { SampleRequestComponent } from './features/self-service-utilities/sample-request/sample-request.component';
import { CreateConfigurationComponent } from './features/buildPak/admin/manage-product/create-configuration/create-configuration.component';
import { NewUserComponent } from './features/new-user/new-user.component';
import { AccountSummaryComponent } from './features/account-Summary/account-summary.component';
import { GenerateWarrantyComponent } from './features/self-service-utilities/generate-warranty/generate-warranty.component';
import { LienReleaseComponent } from './features/self-service-utilities/lien-release/lien-release.component';
import { LanguageTranslationComponent } from './features/buildPak/admin/kawneer-admin/language-translation/language-translation.component';
import { SubmittalPackageAdminComponent } from './features/buildPak/admin/marketing-admin/submittal-package-admin/submittal-package-admin.component';
import { UserAdminComponent } from './features/buildPak/admin/user-admin/user-admin.component';
import { SampleRequestAdminComponent } from './features/buildPak/admin/marketing-admin/sample-request-admin/sample-request-admin.component';
import { ItemAdministrationComponent } from './features/buildPak/admin/kawneer-admin/item-administration/item-administration.component';
import { AddItemComponent } from './features/buildPak/admin/kawneer-admin/item-administration/add-item/add-item.component';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { ServerNameInterceptor } from './core/interceptors/server-name.interceptor'
import { ManageMacroComponent } from './features/buildPak/admin/manage-macro/manage-macro.component';
import { AddNewMacroComponent } from './features/buildPak/admin/manage-macro/add-new-macro/add-new-macro.component';
import { EditNewMacroComponent } from './features/buildPak/admin/manage-macro/edit-new-macro/edit-new-macro.component';
import { BroadcastMessageAdminComponent } from './features/buildPak/admin/marketing-admin/broadcast-message-admin/broadcast-message-admin.component';
import { ErrorDashboardComponent } from './features/buildPak/admin/kawneer-admin/error-dashboard/error-dashboard.component';
import { HomescreenBannerAdminComponent } from './features/buildPak/admin/marketing-admin/homescreen-banner-admin/homescreen-banner-admin.component';
import { ProductConfigComponent } from './features/build-and-buy/product-config/product-config.component';
import { ConfigureNewProductComponent } from './features/build-and-buy/configure-new-product/configure-new-product.component';
import { CreateProductConfigurationComponent } from './features/build-and-buy/product-configuration/create-product-configuration/create-product-configuration.component';
import { OuterFrameProductCOnfigurationComponent } from './features/build-and-buy/product-configuration/outer-frame-product-configuration/outer-frame-product-configuration.component';
import { FrameOptionsProductConfigurationComponent } from './features/build-and-buy/product-configuration/frame-options-product-configuration/frame-options-product-configuration.component';
import { ListValuesProductConfigurationComponent } from './features/build-and-buy/product-configuration/list-values-product-configuration/list-values-product-configuration.component';
import { ConfigureProductComponent } from './features/buildPak/admin/manage-product/configure-product/configure-product.component';
import { ManageFrameComponent } from './features/buildPak/admin/manage-product/create-configuration/manage-frame/manage-frame.component';
import { ConfigureFrameComponent } from './features/buildPak/admin/manage-product/create-configuration/manage-frame/configure-frame/configure-frame.component';
import { SampleRequestNewComponent } from './features/self-service-utilities/sample-request/sample-request-new.component';
import { PromoCodeComponent } from './features/buildPak/admin/marketing-admin/promo-code/promo-code.component';
import { OutageScheduleComponent } from './features/buildPak/admin/marketing-admin/outage-schedule/outage-schedule.component';
import { ImagesAdminComponent } from './features/buildPak/admin/marketing-admin/images-admin/images-admin.component';
import { FaqComponent } from './features/faq/faq.component';
import { BuildConfiguredProductComponent } from './features/build-and-buy/build-configured-product/build-configured-product.component';
import { BuildKwikkeyProductComponent } from './features/build-and-buy/build-kwikkey-product/build-kwikkey-product.component';
import { AddItemToQuoteComponent } from './shared/components/add-item-to-quote/add-item-to-quote.component';
import { Bp1Component } from './features/buildPak/admin/manage-product/configure-product/bp1/bp1.component';
import { Bp2Component } from './features/buildPak/admin/manage-product/configure-product/bp2/bp2.component';
import { Bp3Component } from './features/buildPak/admin/manage-product/configure-product/bp3/bp3.component';
import { TestAttrCComponent } from './features/buildPak/admin/manage-product/configure-product/test-attr-c/test-attr-c.component';
import { ReadonlyAttrTemplateComponent } from './features/buildPak/admin/manage-product/configure-product/readonly-attr-template/readonly-attr-template.component';
import { ImageLoaderDirective } from './core/directives/image-loader.directive';
import { StopWheelDirective} from './core/directives/kendo-numerictextbox-stop-wheel.directive';
import { InchValidateDirective } from './core/directives/inch-validator.directive';
import { QuickAddItemComponent } from './shared/components/quick-add-item/quick-add-item.component';
import { EditConfiguredProductComponent } from './features/build-and-buy/edit-configured-product/edit-configured-product.component';
import { ImportItemComponent } from './shared/components/import-item/import-item.component';
import { CopyConfiguredProductComponent } from './features/build-and-buy/copy-configured-product/copy-configured-product.component';
import { ThermalCalculatorComponent } from './features/self-service-utilities/thermal-calculator/thermal-calculator.component';
import { WindowPricingComponent } from './features/self-service-utilities/window-pricing/window-pricing.component';
import { ProjectSizeDimensionComponent } from './features/self-service-utilities/thermal-calculator/project-size-dimension/project-size-dimension.component';
import { UnauthorizedComponent } from './features/unauthorized/unauthorized.component';
import { ErrorComponent } from './features/error/error.component';
import { LoggedInHeaderComponent } from './core/_layoutComponents/header/logged-in-header/logged-in-header.component';
import { LogoutHeaderComponent } from './core/_layoutComponents/header/logout-header/logout-header.component';
import { CustomerSpecificSchoolComponent } from './features/school-and-training/training/customer-specific-school/customer-specific-school.component';
import { MechanicsSchoolComponent } from './features/school-and-training/training/mechanics-school/mechanics-school.component';
import { MechanicsSchoolAdminComponent } from './features/buildPak/admin/marketing-admin/mechanics-school-admin/mechanics-school-admin.component';
import { CustomerSpecificSchoolAdminComponent } from './features/buildPak/admin/marketing-admin/customer-specific-school-admin/customer-specific-school-admin.component';
import { PreInstallationSystemReviewComponent } from './features/school-and-training/training/pre-installation-system-review/pre-installation-system-review.component';
import { ModulesSchoolComponent } from './features/school-and-training/training/modules-school/modules-school.component';
import { PartnerPakTrainingComponent } from './features/school-and-training/training/partner-pak-training/partner-pak-training.component';
import { ModulesSchoolAdminComponent } from './features/buildPak/admin/marketing-admin/modules-school-admin/modules-school-admin.component';
import { PartnerPakTrainingAdminComponent } from './features/buildPak/admin/marketing-admin/partner-pak-training-admin/partner-pak-training-admin.component';
import { PreInstallationSystemAdminComponent } from './features/buildPak/admin/marketing-admin/pre-installation-system-admin/pre-installation-system-admin.component';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { DetailsScreenComponent } from './features/literature/details-screen/details-screen.component';
import { LieraturePagesComponent } from './features/literature/lierature-pages/lierature-pages.component';
import { ContactUsComponent } from './features/footer-pages/contact-us/contact-us.component';
import { TermsAndConditionsComponent } from './features/footer-pages/terms-and-conditions/terms-and-conditions.component';
import { LegalNoticesComponent } from './features/footer-pages/legal-notices/legal-notices.component';
import { InnerComponent } from './features/literature/inner/inner.component';
import { SurveyAdminComponent } from './features/buildPak/admin/marketing-admin/survey-admin/survey-admin.component';
import { SurveyComponent } from './features/survey/survey.component';
import { ManageTranslationComponent } from './features/buildPak/admin/manage-translation/manage-translation.component';
import { AddTranslationComponent } from './features/buildPak/admin/manage-translation/add-translation/add-translation.component';
import { EditTranslationComponent } from './features/buildPak/admin/manage-translation/edit-translation/edit-translation.component';
import { AddValueTranslationComponent } from './features/buildPak/admin/manage-translation/add-value-translation/add-value-translation.component';
import { EditValueTranslationComponent } from './features/buildPak/admin/manage-translation/edit-value-translation/edit-value-translation.component';
import { ProductSetupComponent } from './features/buildPak/admin/product-setup/product-setup.component';
import { NewsAdminComponent } from './features/buildPak/admin/marketing-admin/news-admin/news-admin.component';
import { environment } from '../environments/environment';
import { OutageComponent } from './features/outage/outage.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NumericTextBoxComponent } from './shared/components/numeric-text-box/numeric-text-box.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { InputValidatorDirective } from './core/directives/input-validator.directive';
import { ReviewComponent } from './features/order-management/invoice-inquiry/payment/review/review.component';
import { PaymentCompleteComponent } from './features/order-management/invoice-inquiry/payment/payment-complete/payment-complete.component';
import { AchPaymentReconcilationComponent } from './features/buildPak/admin/payment-admin/ach-payment-reconcilation/ach-payment-reconcilation.component';
import { OrderSelectionComponent } from './features/self-service-utilities/freight-claim/order-selection/order-selection.component';
import { RaiseClaimComponent } from './features/self-service-utilities/freight-claim/raise-claim/raise-claim.component';
import { ClaimHistoryComponent } from './features/self-service-utilities/freight-claim/claim-history/claim-history.component';
import { ViewClaimDetailsComponent } from './features/self-service-utilities/freight-claim/view-claim-details/view-claim-details.component';
import { ReviewOpenClaimComponent } from './features/buildPak/admin/freight-claim-admin/review-open-claim/review-open-claim.component';
import { ReviewClaimDetailsComponent } from './features/buildPak/admin/freight-claim-admin/review-claim-details/review-claim-details.component';
import { ViewClaimHistoryComponent } from './features/buildPak/admin/freight-claim-admin/view-claim-history/view-claim-history.component';
import { ReviewOpenClaimDetailsComponent } from './features/buildPak/admin/freight-claim-admin/review-open-claim-details/review-open-claim-details.component';
import { ReviewCompletedClaimDetailsComponent } from './features/buildPak/admin/freight-claim-admin/review-completed-claim-details/review-completed-claim-details.component';
import { PaymentCreditCardComponent } from './features/order-management/invoice-inquiry/payment/payment-credit-card/payment-credit-card.component';
import { PaymentCreditcardCompleteComponent } from './features/order-management/invoice-inquiry/payment/payment-creditcard-complete/payment-creditcard-complete.component';
import { SampleRequestOrderHistoryComponent } from './features/buildPak/admin/marketing-admin/sample-request-order-history/sample-request-order-history.component';
import { SampleRequestOrderDetailsComponent } from './features/buildPak/admin/marketing-admin/sample-request-order-details/sample-request-order-details.component';
import { SampleRequestInventoryUsageReportComponent } from './features/buildPak/admin/marketing-admin/sample-request-inventory-usage-report/sample-request-inventory-usage-report.component';
import { SampleRequestReorderReportComponent } from './features/buildPak/admin/marketing-admin/sample-request-reorder-report/sample-request-reorder-report.component';
import { SampleRequestUsageReportComponent } from './features/buildPak/admin/marketing-admin/sample-request-usage-report/sample-request-usage-report.component';
import { AdminBudgetReportComponent } from './features/buildPak/admin/marketing-admin/sample-request-admin/admin-budget-report/admin-budget-report.component';
import { BudgetReportComponent } from './features/buildPak/admin/marketing-admin/sample-request-admin/admin-budget-report/budget-report/budget-report.component';
import { AllocationReportComponent } from './features/buildPak/admin/marketing-admin/sample-request-admin/admin-budget-report/allocation-report/allocation-report.component';

import { HomeComponent as D1 } from './features/discount-store/home/home.component';
import { HomeComponent as D2 } from './features/discount-store/admin/home/home.component';
import { OrderHistoryComponent } from './features/discount-store/admin/home/order-history/order-history.component';
import { OrderDetailsComponent } from './features/discount-store/admin/home/order-history/order-details/order-details.component';
import { ReviewOpenOrdersComponent } from './features/discount-store/admin/review-open-orders/review-open-orders.component';
import { ImportDiscountStoreItemComponent } from './features/discount-store/admin/import-discount-store-item/import-discount-store-item.component';
import { CartCheckoutCreditCardPaymentCompleteComponent } from './features/checkout/cart-checkout-credit-card-payment-complete/cart-checkout-credit-card-payment-complete.component';
import { ExpressCheckoutCardPaymentCompleteComponent } from './features/order-management/manage-quote/kawneerdirect-quotes/quote-detail/express-checkout-card-payment-complete/express-checkout-card-payment-complete.component';
import { OrderFeesComponent } from './features/buildPak/admin/kawneer-admin/order-fees/order-fees.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
 
    AppComponent,
    FooterComponent,
    BreadcrumbComponent,
    HeaderComponent,
    HomeComponent,
    SignInComponent,
    SearchComponent,
    MenuComponent,
    AdvanceSearchComponent,
    NotifyComponent,
    CartComponent,
    ManageAttributeComponent,
    CheckoutComponent,
    OrderdetailsComponent,
    CustomerAddressComponent,
    CartReviewComponent,
    ManageAddressComponent,
    BuildAndBuyComponent,
    ProductCategoryComponent,
    ProductComponent,
    InfoComponent,
    ProductConfigurationComponent,
    OrderManagementComponent,
    ManageQuoteComponent,
    RequestQuoteComponent,
    FactoryQuoteRequestComponent,
    InvoiceInquiryComponent,
    KawneerdirectQuotesComponent,
    InHouseQuotesComponent,
    CaPropComponent,
    InvoiceDetailComponent,
    OrderInquiryComponent,
    OrderDetailComponent,
    QuoteDetailComponent,
    QuickAddQuoteComponent,
    ManageCompanyComponent,
    ManageAccountComponent,
    ManageProductComponent,
    AddNewProductComponent,
    CreditReferenceComponent,
    SubmittalPackageComponent,
    CustomerMultiplierPlanComponent,
    CustomTermsConditionsNotesComponent,
    SampleRequestComponent,
    CreateConfigurationComponent,
    NewUserComponent,
    AccountSummaryComponent,
    GenerateWarrantyComponent,
    LienReleaseComponent,
    LanguageTranslationComponent,
    SubmittalPackageAdminComponent,
    UserAdminComponent,
    SampleRequestAdminComponent,
    ItemAdministrationComponent,
    AddItemComponent,
    ManageMacroComponent,
    AddNewMacroComponent,
    EditNewMacroComponent,
    BroadcastMessageAdminComponent,
    EditNewMacroComponent,
    ErrorDashboardComponent,
    HomescreenBannerAdminComponent,
    ErrorDashboardComponent,
    ProductConfigComponent,
    ConfigureNewProductComponent,
    CreateProductConfigurationComponent,
    OuterFrameProductCOnfigurationComponent,
    FrameOptionsProductConfigurationComponent,
    ListValuesProductConfigurationComponent,
    ConfigureProductComponent,
    ManageFrameComponent,
    ConfigureFrameComponent,
    ProductConfigComponent,
    SampleRequestNewComponent,
    PromoCodeComponent,
    OutageScheduleComponent,
    BuildConfiguredProductComponent,
    BuildKwikkeyProductComponent,   
    ImagesAdminComponent,
    FaqComponent,
    AddItemToQuoteComponent,
    Bp1Component,
    Bp2Component,
    Bp3Component,
    TestAttrCComponent,
    ReadonlyAttrTemplateComponent,
    ImageLoaderDirective,
    StopWheelDirective,
    InchValidateDirective,
    QuickAddItemComponent,
    EditConfiguredProductComponent,
    ImportItemComponent,
    CopyConfiguredProductComponent,
    ThermalCalculatorComponent,
    WindowPricingComponent,
    ProjectSizeDimensionComponent,
    UnauthorizedComponent,
    ErrorComponent,
    LoggedInHeaderComponent,
    LogoutHeaderComponent,
    CustomerSpecificSchoolComponent,
    MechanicsSchoolComponent,
    MechanicsSchoolAdminComponent,
    CustomerSpecificSchoolAdminComponent,
    PreInstallationSystemReviewComponent,
    ModulesSchoolComponent,
    PartnerPakTrainingComponent,
    ModulesSchoolAdminComponent,
    PartnerPakTrainingAdminComponent,
    PreInstallationSystemAdminComponent,
    DetailsScreenComponent,
    LieraturePagesComponent,
    ContactUsComponent,
    TermsAndConditionsComponent,
    LegalNoticesComponent,
    SurveyAdminComponent,
    SurveyComponent,
    InnerComponent,
    ManageTranslationComponent,
    AddTranslationComponent,
    EditTranslationComponent,
    AddValueTranslationComponent,
    EditValueTranslationComponent,
    ProductSetupComponent,
    NewsAdminComponent,
    OutageComponent,
    NumericTextBoxComponent,
    InputValidatorDirective,
    ReviewComponent,
    PaymentCompleteComponent,
    AchPaymentReconcilationComponent,
    OrderSelectionComponent,
    RaiseClaimComponent,
    ClaimHistoryComponent,
    ViewClaimDetailsComponent, 
    ReviewOpenClaimComponent,
    ReviewClaimDetailsComponent,
    ViewClaimHistoryComponent,
    ReviewOpenClaimDetailsComponent,
    ReviewCompletedClaimDetailsComponent,    
    PaymentCreditCardComponent, PaymentCreditcardCompleteComponent,
    
    SampleRequestOrderHistoryComponent,
    SampleRequestOrderDetailsComponent,
    SampleRequestInventoryUsageReportComponent,
    SampleRequestReorderReportComponent,
    SampleRequestUsageReportComponent,
    AdminBudgetReportComponent,
    BudgetReportComponent,
    AllocationReportComponent,
    D1,
    D2,   
    OrderHistoryComponent,
    OrderDetailsComponent,
    ReviewOpenOrdersComponent,
    ImportDiscountStoreItemComponent,
    CartCheckoutCreditCardPaymentCompleteComponent,
    ExpressCheckoutCardPaymentCompleteComponent,
    OrderFeesComponent,

    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    RouterModule,
    HttpClientModule,
    HttpClientJsonpModule,
    LabelModule,
    PrimeNgModule,
    NgxPaginationModule,
    IndicatorsModule,
    TooltipModule,
    TextBoxModule,
    FormFieldModule,
    KendoModule,
    NgIdleKeepaliveModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: "registerImmediately"
    })
  ],
  exports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    RouterModule,
    HttpClientModule,
    HttpClientJsonpModule,
    LabelModule,
    PrimeNgModule,
    NgxPaginationModule,
    IndicatorsModule,
    TooltipModule,
    TextBoxModule,
    FormFieldModule
  ],
  providers: [CookieService, {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true
  },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ServerNameInterceptor,
      multi: true
    }, CurrencyPipe,
    { provide: LocationStrategy, useClass: PathLocationStrategy }, DeviceDetectorService  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
